import { typedFetch } from "@/lib/helpers";
import { API_BASE_URL } from "../urls.api";
import { API_METHODS } from "../shared";

export type IntegrationType =
  | "guesty"
  | "avantio"
  | "kross"
  | "hostify"
  | "hostaway"
  | "rentalready"
  | "icnea";

export interface UnlinkIntegrationRequest {
  integrationType: IntegrationType;
  keepFutureBookings: boolean;
}

export const unlinkIntegration = async (
  roomId: string,
  data: UnlinkIntegrationRequest
): Promise<void> => {
  const result = await typedFetch(`${API_BASE_URL}/rooms/${roomId}/unlink-integration`, {
    method: API_METHODS.POST,
    body: JSON.stringify(data),
  });

  if (!result.ok) {
    const responseJson = await result.json();
    throw new Error(responseJson.message || "Failed to unlink integration");
  }
};

export const unlinkIntegrationDeleteAll = async (
  roomId: string,
  data: Pick<UnlinkIntegrationRequest, "integrationType">
): Promise<void> => {
  const result = await typedFetch(`${API_BASE_URL}/rooms/${roomId}/unlink-integration-delete-all`, {
    method: API_METHODS.POST,
    body: JSON.stringify(data),
  });

  if (!result.ok) {
    const responseJson = await result.json();
    throw new Error(responseJson.message || "Failed to unlink integration and delete all bookings");
  }
};
